import './_Planet.scss'
import { useLottie } from 'lottie-react'
import planetAnimation from './planet.json'

function Planet() {
	const options = {
		animationData: planetAnimation,
		loop: true,
	}

	const { View } = useLottie(options)

	return <div className="planet">{View}</div>
}

export default Planet
